import { useEffect, useState } from 'react';

import moment from 'moment';
import { FaEllipsisV } from 'react-icons/fa';
import DataTable from 'react-data-table-component';
import { Card, CardBody, CardFooter, CardHeader, Col, Row, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';

import { TablePagination } from '../../../../../../../Common';
import { Constant } from '../../../../../../../Helpers/constant';
import { PermissionConstants } from '../../../../../../../Helpers/Constants/permissions';
import { formattedWithComma, hasPermission } from '../../../../../../../Helpers/Helpers';
import { adibProjectsUrl } from '../../../../../../../Config';
import cogoToast from 'cogo-toast';

const Table = props => {
  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  const statusMapping = {
    1: { text: 'Pending', color: 'warning' },
    2: { text: 'Accepted', color: 'success' },
    3: { text: 'Rejected', color: 'danger' },
    4: { text: 'Blocked', color: 'danger' },
  };

  useEffect(() => {
    if (props?.data?.length > 0) {
      const fetchColumns = [
        {
          name: 'S.No',
          width: '90px',
          selector: row => <span className="fw-medium">{row?.serialNumber}</span>,
        },
        {
          name: 'Company Name',
          width: '200px',
          selector: row => row?.companyName,
          wrap: true,
        },
        {
          name: 'Category',
          width: '200px',
          selector: row => row?.categoryName,
          wrap: true,
        },
        {
          name: 'Spoc Name',
          selector: row => row?.spocName,
          wrap: true,
          width: '160px',
        },
        {
          name: 'Spoc Designation',
          selector: row => row?.spocDesignation,
          width: '150px',
          wrap: true,
        },
        {
          name: 'Location',
          selector: row => row?.location,
          width: '150px',
          wrap: true,
        },
        {
          name: 'Date & Time',
          selector: row => row?.dateAndTime,
          width: '180px',
          wrap: true,
        },
        {
          name: 'Status',
          cell: row => {
            const status = statusMapping[row?.status] || { text: 'Unknown', color: 'muted' };
            return <span className={`badge bg-${status?.color}`}>{status?.text}</span>;
          },
          width: '150px',
          wrap: true,
        },
        {
          name: 'Actions',
          width: '200px',
          style: { justifyContent: 'center' },
          cell: row => (
            <div className="d-flex justify-content-center flex-column m-4">
              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.ADIB_WRITE) && (
                <>
                  {row?.originalData?.status === 1 && (
                    <>
                      <button
                        className="btn btn-sm btn-success mb-1"
                        onClick={() => actionBtnHandler('ACCEPT', row?.originalData)}
                        style={{ width: '150px' }}
                      >
                        Accept
                      </button>

                      <button
                        className="btn btn-sm btn-danger mb-1"
                        onClick={() => actionBtnHandler('REJECT', row?.originalData)}
                        style={{ width: '150px' }}
                      >
                        Reject
                      </button>
                    </>
                  )}
                  {row?.originalData?.status && row?.originalData?.status !== 1 && row?.originalData?.status !== 3 && (
                    <>
                      {row?.originalData?.status !== 4 && (
                        <button
                          className="btn btn-sm btn-warning mb-1"
                          onClick={() => actionBtnHandler('BLOCK', row?.originalData)}
                          style={{ width: '150px' }}
                          disabled={row?.originalData?.status === 4}
                        >
                          Block
                        </button>
                      )}

                      {row?.originalData?.status === 4 && (
                        <button
                          className="btn btn-sm btn-success mb-1"
                          onClick={() => actionBtnHandler('UNBLOCK', row?.originalData)}
                          style={{ width: '150px' }}
                          disabled={row?.originalData?.status !== 4}
                        >
                          Unblock
                        </button>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          ),
        },
        {
          name: 'User Actions',
          width: '200px',
          style: { justifyContent: 'center' },
          cell: row => (
            <div className="d-flex justify-content-center flex-column m-4">
              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.ADIB_WRITE) && (
                <>
                  {row?.originalData?.postCreationFlag === 0 && (
                    <button
                      className="btn btn-sm btn-success mb-1"
                      onClick={() => actionBtnHandler('POST_ACTIVE', row?.originalData)}
                      style={{ width: '150px' }}
                    >
                      Activate Post
                    </button>
                  )}
                  {row?.originalData?.postCreationFlag === 1 && (
                    <button
                      className="btn btn-sm btn-danger mb-1"
                      onClick={() => actionBtnHandler('POST_INACTIVE', row?.originalData)}
                      style={{ width: '150px' }}
                    >
                      Deactivate Post
                    </button>
                  )}
                </>
              )}
            </div>
          ),
        },
        {
          name: 'View Page',
          cell: row => (
            <UncontrolledDropdown className="dropdown d-inline-block">
              <DropdownToggle className="btn btn-soft-secondary btn-sm" tag="button">
                <FaEllipsisV style={{ cursor: 'pointer' }} />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem onClick={() => viewPageHandler('USER_REGISTRATION', row?.originalData)}>User Registration</DropdownItem>
                <DropdownItem onClick={() => viewPageHandler('BUSINESS_PROFILE_CREATION', row?.originalData)}>Business Profile Creation</DropdownItem>
                <DropdownItem onClick={() => viewPageHandler('COMPANY_PAGE', row?.originalData)}>Company Page</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          ),
          width: '100px',
          wrap: true,
        },
        {
          name: 'Ask More',
          width: '100px',
          cell: row => (
            <>
              {hasPermission(PermissionConstants.ALL_PERMISSIONS.ADIB_WRITE) && (
                <UncontrolledDropdown className="dropdown d-inline-block">
                  <DropdownToggle className="btn btn-soft-secondary btn-sm" tag="button">
                    <FaEllipsisV style={{ cursor: 'pointer' }} />
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => actionBtnHandler('QUESTION_ASKED', row?.originalData)}>More Details</DropdownItem>
                    <DropdownItem onClick={() => actionBtnHandler('QUES_ANS', row?.originalData)}>View Response</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </>
          ),
        },
      ];

      setColumns(fetchColumns);
      setData(
        props?.data?.map((data, index) => {
          return {
            serialNumber: `${props?.pageNumber * Constant.TABLE_PAGE_SIZE + (index + 1)}.`,
            companyName: data?.companyName || `NA`,
            categoryName: data?.categoryName || `NA`,
            spocName: data?.firstName || data?.lastName ? `${data?.firstName || ''} ${data?.lastName || ''}` : `NA`,
            spocDesignation: data?.designation || `NA`,
            location: data?.locationName || `NA`,
            dateAndTime: data?.createdAt ? moment(new Date(`${data?.createdAt}`)).format('DD-MM-YYYY, h:mm A') : 'NA',
            status: data?.status,
            originalData: data || `NA`,
          };
        }),
      );
    } else {
      setData([]);
      setColumns([]);
    }
  }, [props?.data, props?.pageNumber]);

  /* ---------------------------- ACTION HANDLER ---------------------------- */
  const actionBtnHandler = (flag, data) => {
    props.actionHandler({ companyDetails: data, actionType: flag });
  };

  const viewPageHandler = (flag: string, data) => {
    switch (flag) {
      case 'USER_REGISTRATION':
        window.open(`${adibProjectsUrl}/preview/user?userId=${data?.userId}&auth=${Constant.CLIENT_TOKEN}`);
        break;
      case 'BUSINESS_PROFILE_CREATION':
        window.open(`${adibProjectsUrl}/preview/business?userId=${data?.userId}&auth=${Constant.CLIENT_TOKEN}`);
        break;
      case 'COMPANY_PAGE':
        window.open(`${adibProjectsUrl}/preview/profile-preview?userId=${data?.userId}&auth=${Constant.CLIENT_TOKEN}`);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Company List</h4>
              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.ADIB_DOWNLOAD) && props?.data?.length > 0 && (
                <span className="btn btn-success mb-1" onClick={props?.dumpDownload}>
                  <i className="ri-download-line me-1 text-white fs-14 align-middle"></i>Download dump
                </span>
              )}
            </CardHeader>

            <CardBody>
              <DataTable
                columns={columns}
                data={data}
                customStyles={{
                  headRow: {
                    style: {
                      borderBottom: '1px solid #ddd',
                      backgroundColor: '#f9fafb',
                      fontWeight: '600',
                    },
                  },
                  cells: {
                    style: {
                      border: '0.5px solid #ddd',
                      borderBottom: '0px solid #ddd',
                    },
                  },
                }}
              />
            </CardBody>

            {data?.length > 0 && (
              <CardFooter>
                <Row className="custom_pagination">
                  <Col md={12} className="d-flex justify-content-between align-items-center">
                    <div>
                      Showing <b>{formattedWithComma(String(props?.pageNumber * Constant?.TABLE_PAGE_SIZE + 1))}</b> to&nbsp;
                      <b>{formattedWithComma(props?.pageNumber * Constant?.TABLE_PAGE_SIZE + props?.data?.length)}</b> of{' '}
                      <b>{formattedWithComma(props?.totalData)}</b> records
                    </div>
                    <div className="d-flex justify-content-end">
                      <TablePagination totalData={props?.totalData} currentPage={props?.pageNumber} onPageChangeHandler={props?.pageHandler} />
                    </div>
                  </Col>
                </Row>
              </CardFooter>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Table;
